import { on as onEvent } from "common/utils/ui/event";

const SELECTORS = {
  modal: ".js-reseller-pricing-modal",
  closeButton: ".js-reseller-pricing-modal-close",
  openButtons:
    ".js-masthead-account-dropdown, .js-wholesale-learn-more-pdp, .js-reseller-pricing-button-dl"
};

class ResellerPricingModal {
  // eslint-disable-next-line class-methods-use-this
  get #$modal() {
    return document.querySelector(SELECTORS.modal);
  }

  get #$closeBtn() {
    return this.#$modal?.querySelector(SELECTORS.closeButton);
  }

  constructor() {
    if (this.#$modal) {
      this.#bindEvents();
    }
  }

  #bindEvents() {
    // Open button click - bind to all instances (mobile + desktop)
    onEvent("click", SELECTORS.openButtons, e => {
      e.preventDefault();
      this.open();
    });

    // Close button click
    this.#$closeBtn?.addEventListener("click", () => this.close());

    // Backdrop click (clicking outside the modal content)
    this.#$modal?.addEventListener("click", e => {
      if (e.target === this.#$modal) {
        this.close();
      }
    });

    // Native dialog close event (fires on ESC key) - cleanup scroll lock
    this.#$modal?.addEventListener("close", () => {
      document.documentElement.classList.remove("locked-all");
    });
  }

  open() {
    this.#$modal?.showModal();
    document.documentElement.classList.add("locked-all");
  }

  close() {
    this.#$modal?.close();
    document.documentElement.classList.remove("locked-all");
  }
}

const init = () => {
  // eslint-disable-next-line no-new
  new ResellerPricingModal();
};

export default init;
